import { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import parse from 'html-react-parser'

import {
  ROUTE_DAILY_REMBLE,
  ROUTE_COURSES_ALL,
  ROUTE_ACTIVITIES_JOURNALING_ALL,
  ROUTE_ACTIVITIES_RELATIONSHIPQA_ALL,
  ROUTE_ACTIVITIES_AFFIRMATIONS_ALL,
  ROUTE_TODAY,
  ROUTE_ACTIVITIES_BREATHING_ALL,
  ROUTE_ACTIVITIES_COPINGSKILLS_ALL,
  ROUTE_ACTIVITIES_MEDITATION_ALL
} from 'components/common/helpers/Paths'
import {
  buildRequestURL,
  KEY_PRACTICE_AFFIRMATIONS,
  KEY_PRACTICE_BREATHWORK,
  KEY_PRACTICE_COPING_SKILLS,
  KEY_PRACTICE_DAILY_REMBLE,
  KEY_PRACTICE_JOURNALING,
  KEY_PRACTICE_MEDITATIONS,
  KEY_PRACTICE_RELATIONSHIPQA
} from 'components/common/api'
import { navigateTo } from 'components/common/navigation'
import { LMS_TYPE_COURSES } from 'components/common/api/Courses'

const _urlGenerators = {
  [KEY_PRACTICE_AFFIRMATIONS]: affirmation =>
    `${ROUTE_ACTIVITIES_AFFIRMATIONS_ALL}/${affirmation.id}`,
  [KEY_PRACTICE_BREATHWORK]: breathwork =>
    `${ROUTE_ACTIVITIES_BREATHING_ALL}/${breathwork.id}`,
  [KEY_PRACTICE_COPING_SKILLS]: skill =>
    `${ROUTE_ACTIVITIES_COPINGSKILLS_ALL}/${skill.id}`,
  [KEY_PRACTICE_DAILY_REMBLE]: dailyRemble =>
    `${ROUTE_DAILY_REMBLE}/${dailyRemble.id}`,
  // Legacy
  daily_remble: dailyRemble => `${ROUTE_DAILY_REMBLE}/${dailyRemble.id}`,
  [KEY_PRACTICE_JOURNALING]: journal =>
    `${ROUTE_ACTIVITIES_JOURNALING_ALL}/${journal.id}`,
  [KEY_PRACTICE_MEDITATIONS]: meditation =>
    `${ROUTE_ACTIVITIES_MEDITATION_ALL}/${meditation.id}`,
  [KEY_PRACTICE_RELATIONSHIPQA]: questions =>
    `${ROUTE_ACTIVITIES_RELATIONSHIPQA_ALL}/${questions.id}`,
  [LMS_TYPE_COURSES]: course => `${ROUTE_COURSES_ALL}/${course.id}`
}
/**
 * TimelineEvent component. Used to display timeline events within a `Timeline` component
 */
function TimelineEvent({ event, style }) {
  const history = useHistory()
  const [title, setTitle] = useState('')
  const [description, setDescription] = useState('')
  const [thumbnail, setThumbnail] = useState('')

  /**
   * Event handler for timeline event click
   */
  const handleEventClick = timelineEvent => {
    const returnPath = ROUTE_TODAY
    let url

    try {
      // Generate the URL based on the event type
      url = _urlGenerators[timelineEvent.type](timelineEvent)
    } catch (e) {
      console.error(e)
    }

    // Return early if no url
    if (!url) return

    // Append the return path to the url
    url = buildRequestURL(url, { returnPath })

    // Navigate to the url
    navigateTo(url, history)
  }

  // Set the title and description
  useEffect(() => {
    // Return early if no event
    if (!event) return

    // Set the title and description
    let eventThumbnail = '',
      eventTitle = '',
      eventDescription = ''

    try {
      eventThumbnail = event.featured_image_thumbnail_url || event.image
      eventTitle = event.title?.rendered
        ? parse(event.title.rendered.trim())
        : ''

      eventDescription = event.content?.rendered
        ? parse(event.description)
        : event.acf_extended?.author[0]?.post_title
    } catch (e) {
      console.error(e)
    }

    setTitle(eventTitle)
    setDescription(eventDescription)
    setThumbnail(eventThumbnail)
  }, [event])

  // Return early if no event
  if (!event) return null

  return (
    <div
      className='timeline-event'
      style={style}
      onClick={_ => handleEventClick(event)}
    >
      <div
        className='timeline-event-thumbnail'
        style={{
          backgroundImage: `url(${thumbnail})`
        }}
      ></div>
      <h6 className='timeline-event-title'>{title}</h6>
      <div className='timeline-event-description'>{description}</div>
    </div>
  )
}

export default TimelineEvent
